import type { Role } from "@nova-ai/shared"
import { ROLES } from "@nova-ai/shared"

import { Combobox } from "../ui/combobox"

const roleOptions = ROLES.map((role) => ({ value: role, label: role }))

type UserRoleSelectProps = {
  role: Role
  disabled?: boolean
  onChange: (role: Role) => void
}

export function UserRoleSelect({ role, disabled, onChange }: UserRoleSelectProps) {
  return (
    <Combobox
      aria-label="Role"
      size="sm"
      value={role}
      disabled={disabled}
      options={roleOptions}
      searchPlaceholder="Search roles…"
      emptyMessage="No roles"
      onChange={(value) => {
        if (value !== undefined) {
          onChange(value as Role)
        }
      }}
    />
  )
}
